import { FC } from "react";

import { DocumentTypeEnumType } from "@libs/api/patients";
import { VnBox } from "@/components/VnBox";
import { VnButton } from "@/components/VnButton/VnButton";
import { VnCard } from "@/components/VnCard";
import {
  VnDialog,
  VnDialogContent,
  VnDialogFooter,
  VnDialogHeader,
} from "@/components/VnDialog";
import { VnText } from "@/components/VnText/VnText";
import { VnTouchableOpacity } from "@/components/VnTouchableOpacity";
import { DocumentTypeOptionType } from "@/domain/uploadedDocuments";
import { cn } from "@/utils/tailwind";

type DocumentTypeSelectDialogPropsType = {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  documentTypeOptions: DocumentTypeOptionType[];
  selectedDocumentType: DocumentTypeEnumType | null;
  onSelectDocumentType: (documentType: DocumentTypeEnumType) => void;
  onNext: () => void;
};

export const DocumentTypeSelectDialog: FC<
  DocumentTypeSelectDialogPropsType
> = ({
  isOpen,
  onOpenChange,
  documentTypeOptions,
  selectedDocumentType,
  onSelectDocumentType,
  onNext,
}) => (
  <VnDialog open={isOpen} onOpenChange={onOpenChange}>
    <VnDialogContent className="bg-background h-[100dvh] max-h-full w-screen max-w-full rounded-none border-0 sm:h-auto sm:max-h-[90dvh] sm:rounded-lg sm:border">
      <VnDialogHeader className="relative shrink-0 flex-row items-center justify-center">
        <VnText
          variant="headerTwo"
          className="flex-1 text-center"
          i18nKey="native:applicantDocuments.selectDocumentType"
        />
      </VnDialogHeader>
      <VnBox
        className="flex w-full flex-1 flex-col gap-y-4 overflow-y-scroll"
        shouldHideScrollIndicator>
        {documentTypeOptions.map(({ i18nKey, value }) => (
          <VnTouchableOpacity
            key={value}
            onPress={() => onSelectDocumentType(value)}>
            <VnCard
              className={cn(
                "bg-secondary border-border w-full items-center rounded-lg border p-3",
                selectedDocumentType === value && "border-sidebar",
              )}>
              <VnText
                variant="lg"
                className="text-card-foreground self-start"
                i18nKey={i18nKey}
              />
            </VnCard>
          </VnTouchableOpacity>
        ))}
      </VnBox>
      <VnDialogFooter className="items-end">
        <VnButton
          className="mt-5"
          size="lg"
          i18nKey="common:next"
          onPress={onNext}
          disabled={!selectedDocumentType}
        />
      </VnDialogFooter>
    </VnDialogContent>
  </VnDialog>
);
